import { Link } from 'react-router-dom';
import { img, readdy } from '@/utils/images';
import { solutionFeatures } from '@/mocks/homeData';
import { getSiteConfig } from '@/utils/siteConfigStore';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function SolutionGrid() {
  const { brandStats } = getSiteConfig();
  return (
    <section className="relative bg-brand-white py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <img
          src={readdy('solution-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="mb-12 md:mb-16">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">核心优势</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                专业体系，
                <br />
                铸就品牌核心竞争力
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {solutionFeatures.map((feature, i) => (
              <ScrollReveal key={feature.title} variant="fade-up" delay={i * 120}>
                <div className="bg-white rounded-2xl p-8 md:p-10 border border-brand-light/60 hover:border-brand-cream hover:shadow-lg transition-all duration-300 group cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-brand-light mb-6 group-hover:bg-brand-cream transition-colors">
                    <i className={`${feature.icon} text-brand-deep text-xl`} />
                  </div>
                  <h3 className="text-lg font-semibold text-brand-deep mb-3">{feature.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{feature.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal variant="fade-up" delay={200}>
            <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
              {brandStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-3xl md:text-4xl font-bold text-brand-deep mb-2">{stat.value}</p>
                  <p className="text-xs text-gray-400">{stat.label}</p>
                </div>
              ))}
            </div>
          </ScrollReveal>

          <ScrollReveal variant="fade-up" delay={300}>
            <div className="mt-12 text-center">
              <Link
                to="/solutions"
                className="inline-flex items-center gap-2 px-7 py-3 bg-brand-deep text-white text-sm font-medium rounded-full hover:bg-brand-dark transition-colors cursor-pointer"
              >
                了解健康纤体方案
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}